import React from "react"
import styled from "styled-components"
import { theme } from "Theme"
import { Wrapper } from "Styles"

const Content = styled.div`
  width: 100%;
  padding: 1rem 0 0;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  .Collapsible {
    overflow: hidden;
    .Collapsible__trigger {
      color: ${theme.colors.black.base};
      background: ${theme.colors.white.light};
      font-weight: bold;
      font-size: ${theme.fontSize.p};
      width: 100%;
      max-width: ${theme.layout.base};
      padding: 1rem;
      margin: 0;
      cursor: pointer;
      position: relative;
      border: 1px solid ${theme.colors.white.grey};
      &:hover {
        color: ${theme.colors.primary.base};
        &:after {
          content: "";
          display: inline-block;
          height: 0.5em;
          vertical-align: bottom;
          width: 100%;
          margin-right: -100%;
          margin-left: 10px;
          border-top: none;
        }
      }
      &:before {
        color: ${theme.colors.primary.base};
        background-color: transparent;
        border: 1px solid ${theme.colors.white.grey};
        background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDE4IDEyIj4KICA8cGF0aCBmaWxsPSIjMGUxZTI1IiBkPSJNMy4xNC42NjdsNS4wMSA0LjU5Yy40Ny40MyAxLjIzLjQzIDEuNyAwbDUuMDEtNC41OUwxOCAzLjU0NCA5Ljg1IDExLjAxYy0uNDcuNDMtMS4yMy40My0xLjcgMEwwIDMuNTQ1IDMuMTQuNjY3eiIvPgo8L3N2Zz4K);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 0.8em;
        content: "";
        height: 2rem;
        position: absolute;
        right: 8px;
        top: 8px;
        transition: ${theme.transitions.default.transition};
        width: 2rem;
        border-radius: ${theme.borderRadius.elements};
      }
      &:after {
        content: "";
        display: inline-block;
        height: 0.5em;
        vertical-align: bottom;
        width: 100%;
        margin-right: -100%;
        margin-left: 10px;
        border-top: none;
      }
    }
    &.collapsible-open {
      .Collapsible__contentOuter {
        margin: 1rem 0;
      }
      .Collapsible__trigger.is-open {
        &:before {
          transform: rotate(-180deg);
        }
      }
    }
  }
`

const Grid = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: ${theme.layout.base};
`

const EventsListGrid = styled.div`
  display: grid;
  @media (min-width: ${theme.breakpoints.s}) {
  }
  @media (min-width: ${theme.breakpoints.m}) {
    grid-template-columns: repeat(auto-fill, minmax(32%, 1fr));
  }
  @media (min-width: ${theme.breakpoints.l}) {
  }
  grid-gap: 1rem;
  .option-card {
    padding: 1rem;
    box-shadow: ${theme.shadow.feature.small.default};
  }
`

const EventsList = ({ big, dark, layout }) => (
  <Wrapper layout={layout} dark={dark ? 1 : undefined} big={big}>
    <Content>
      <Grid>
        <EventsListGrid>
          {/* {data.map((event, i) => (
            <EventCard key={i} className={`XXXXXX`}>
              <EventCalendarList
                full={true}
                featured={false}
                photo={''}
                key={event.node.event.id}
                event={event.node.event}
                // share={this.toggleModal(
                //   MODAL_SHARE_EVENT,
                //   data.node.event
                // )}
                // calendar={this.toggleModal(
                //   MODAL_ADD_CALENDAR,
                //   data.node.event
                // )}
              />
            </EventCard>
          ))} */}
          {/* <EventCardEmpty className={``}>
            <Link to={"/events/"}>
              <div className="event-list-contents">
                <div className="event-list-featured">
                  <p className="event-card-city">{`Browse more Events >`}</p>
                </div>
              </div>
            </Link>
          </EventCardEmpty> */}
        </EventsListGrid>
      </Grid>
    </Content>
  </Wrapper>
)

export default EventsList
